const canManageFranchiseSettings = (user) =>
  !!(
    user?.isSuperAdmin ||
    user?.userType?.toLowerCase() === "owner" ||
    user?.role?.toLowerCase() === "owner"
  );

export default canManageFranchiseSettings;
